<div
  class="platform-switcher position-relative w-100"
>
  <button
    class="platform-switcher-toggle d-flex align-items-center text-decoration-none w-100 rounded"
    type="button"
    aria-label="Data Warehousing"
    data-tooltip="Data Warehousing"
    :disabled="is_switching || !primary_platform"
    @click="switch_to_primary_platform"
  >
    <span v-if="has_clicked_switch" class="platform-switcher-logo me-2" aria-hidden="true"></span>
    <i v-else class="bi bi-window-stack platform-switcher-icon me-2" aria-hidden="true"></i>
    <span class="platform-switcher-text sidebar-menu-text text-white-50 fw-semibold text-xs">
      Data Warehousing
    </span>
    <span v-if="is_switching" class="spinner-border spinner-border-sm ms-auto"></span>
  </button>

  <p v-if="error_message" class="platform-switcher-error text-danger small px-1 pt-2 mb-0">
    {{ error_message }}
  </p>
</div>
